export default __webpack_public_path__ + "static/media/DiaImageComingSoon.4e5f4552.jpg";